export const CANVAS_PREVIEW_STORAGE_KEY = "scrollx.canvasPreview";

// Block types whose canvas layout matches the DOM preview. A project only
// switches to the canvas renderer when every one of its blocks is listed.
export const CANVAS_SUPPORTED_TYPES = new Set([
  "blurb",
  "nameonly",
  "rolename",
  "song",
  "logo",
]);

export const isCanvasPreviewFlagOn = () => {
  try {
    return (
      typeof window !== "undefined" &&
      window.localStorage?.getItem(CANVAS_PREVIEW_STORAGE_KEY) === "1"
    );
  } catch {
    return false;
  }
};

export const CANVAS_PREVIEW_FLAG_EVENT = "scrollx:canvas-preview-flag";

export const setCanvasPreviewFlag = (enabled) => {
  try {
    if (enabled) window.localStorage.setItem(CANVAS_PREVIEW_STORAGE_KEY, "1");
    else window.localStorage.removeItem(CANVAS_PREVIEW_STORAGE_KEY);
  } catch {
    return;
  }
  window.dispatchEvent(new CustomEvent(CANVAS_PREVIEW_FLAG_EVENT));
};

/** Re-render on flag changes from this tab or another one. */
export const subscribeCanvasPreviewFlag = (callback) => {
  const onStorage = (event) => {
    if (event.key === CANVAS_PREVIEW_STORAGE_KEY) callback();
  };
  window.addEventListener(CANVAS_PREVIEW_FLAG_EVENT, callback);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(CANVAS_PREVIEW_FLAG_EVENT, callback);
    window.removeEventListener("storage", onStorage);
  };
};

if (typeof window !== "undefined") {
  window.__scrollxCanvasPreview = setCanvasPreviewFlag;
}

export const getUnsupportedCanvasBlockTypes = (credits = []) =>
  [
    ...new Set(
      (credits || [])
        .map((credit) => credit?.options?.block_type)
        .filter((type) => !CANVAS_SUPPORTED_TYPES.has(type)),
    ),
  ];

export const isCanvasPreviewEnabled = (projectData) => {
  if (!projectData) return false;
  if (!isCanvasPreviewFlagOn()) return false;
  return getUnsupportedCanvasBlockTypes(projectData.credits).length === 0;
};
